import {
  Button,
  Modal,
  ModalActions,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalTitle,
} from "@onengine/component-library";
import { useFileManager, useFileManagerUI } from "@/components/core/FileManager";
import { notifications } from "@mantine/notifications";

import styles from "./DeleteModal.module.scss";

export function DeleteModal() {
  const { deleteFiles } = useFileManager();
  const { deleteTarget, closeDelete } = useFileManagerUI();

  const isMulti = (deleteTarget?.items.length ?? 0) > 1;
  const title = isMulti
    ? `Delete ${deleteTarget?.items.length} items`
    : `Delete "${deleteTarget?.items[0]?.name}"`;

  function handleDelete() {
    if (!deleteTarget) return;
    deleteFiles(
      { items: deleteTarget.items },
      {
        onSuccess: closeDelete,
        onError: () => {
          notifications.show({
            title: "Delete failed",
            message: "Could not delete. Please try again.",
            color: "red",
            autoClose: 4000,
          });
        },
      },
    );
  }

  return (
    <Modal open={!!deleteTarget} onClose={closeDelete}>
      <ModalContent>
        <ModalTitle>{title}</ModalTitle>
        <ModalBody>
          <p className={styles.message}>
            {isMulti ? (
              <>
                Delete <strong>{deleteTarget?.items.length} items</strong>? This cannot be undone.
              </>
            ) : (
              <>
                Delete <strong>{deleteTarget?.items[0]?.name}</strong>? This cannot be undone.
              </>
            )}
          </p>
        </ModalBody>
        <ModalFooter>
          <ModalActions position={"right"}>
            <Button variant="neutral-secondary" onClick={closeDelete}>
              Cancel
            </Button>
            <Button variant="destructive-primary" onClick={handleDelete}>
              Delete
            </Button>
          </ModalActions>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
